import parseDate from "@/helpers/parseDate";
import toScheduleEvent from "./to-schedule-event";
import ScheduleCalendar from "@/schedule/entities/schedule-calendar";

export default function toScheduleCalendar(data: any): ScheduleCalendar {
  return {
    user: {
      id: data.user.userId,
      name: data.user.name,
      icon: data.user.icon.imageURL
    },
    days: data.days.map((d: any) => {
      const date = parseDate(d.date);
      return {
        ...d,
        date,
        events: d.events.map(toScheduleEvent)
      };
    })
  };
}
